export default class Campaigns {
    constructor(api) {
        this.api = api;
        this.campaignsClass = null;
    }

    async init(instance) {
        if (this.api && this.api.settings && this.api.settings.campaignsInstance && this.api.settings.campaignsInstance !== instance.instance) {
            return;
        }

        if (!this.campaignsClass) {
            if (instance.data && instance.data.cdn && instance.data.cdn.js) {
                await this.api.util.loadJS(instance.data.cdn.js);
                // await this.api.util.loadJS(["http://localhost:8081/widget_campaigns.js"]);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.campaigns &&
                this.api.settings.widgetsUrl.campaigns.js
            ) {
                await this.api.util.loadJS([this.api.settings.widgetsUrl.campaigns.js]);
            }

            if (instance.data && instance.data.cdn && instance.data.cdn.css) {
                await this.api.util.loadCSS(instance.data.cdn.css);
                //await this.api.util.loadCSS(['http://localhost:63342/widgets/dist/campaigns/css/campaigns.css']);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.campaigns &&
                this.api.settings.widgetsUrl.campaigns.css
            ) {
                await this.api.util.loadCSS([this.api.settings.widgetsUrl.campaigns.css]);
            }
        }

        if (window.store) {
            window.store.dispatch('addInstanceToContainer', instance.instance)
            this.createInstance(instance)
        }
    }

    createInstance(instance) {
        if (!document.getElementById(`ox-drawer-instance-container-${instance.instance}-inner`)) {
            setTimeout(()=> {
                this.createInstance(instance)
            },100)
        } else {
            this.campaignsClass = new window.Widget_campaigns.default(this.api.settings, `#ox-drawer-instance-container-${instance.instance}-inner`, instance.instance, this.api);
        }
    }
}